module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1008-349bba4976af349a58d05f1737167e02.png";